<template>
    <div class="embed-twitch">
        <missing-video
            v-if="!cookies.video"
            class="w-full aspect-video"
            entity="stream"
            :poster="poster"
        ></missing-video>
        <div v-else>
            <div v-show="online" :id="'twitch-embed-' + username" class="w-full aspect-video"></div>
            <div v-show="!online" class="w-full aspect-video relative">
                <div class="absolute z-10 top-3 left-3 px-3 py-2 bg-black/75 text-white font-bold text-sm rounded-full">
                    BACK SOON!
                </div>
                <img :src="poster" class="w-full aspect-video" alt />
            </div>
        </div>
        <div
            class="mt-4 flex flex-col sm:flex-row space-y-1 sm:space-y-0 sm:space-x-3 truncate text-base sm:text-base lg:text-lg"
            v-if="$slots.schedule"
        >
            <slot name="schedule"></slot>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    image: {
        required: true,
        type: String,
        default: null,
    },
    username: {
        required: true,
        type: String,
        default: null,
    },
});

const $config = useRuntimeConfig();

const poster = computed(() => {
    return props.image ? props.image : $config.public.images + 'live-stream-offline.png';
});

const {cookies} = storeToRefs(useStoreCookies());

let twitch = null;
let error = null;
let online = useState(props.username + '-online', () => false);

const emit = defineEmits(['play', 'progress', 'pause', 'destroy']);

const timer = ref(null);
const totalTime = ref(0);

function startTimer() {
    if (timer.value) return;
    timer.value = setInterval(function () {
        totalTime.value += 1;
        emit('progress', {totalTime: totalTime.value, currentTime: totalTime.value});
    }, 1000);
}

function stopTimer() {
    if (timer.value) {
        clearInterval(timer.value);
        timer.value = null;
    }
}

onMounted(async () => {
    watch(
        cookies,
        async () => {
            if (cookies.value.video) {
                twitch = usePluginTwitch();
                await twitch.init();
                twitch.attachPlayer(props.username, 'twitch-embed-' + props.username, onPlayerUpdate);
            }
        },
        {immediate: true},
    );

    function onPlayerUpdate(state) {
        switch (state) {
            case 'offline':
                online.value = false;
                console.log('Twitch offline');
                emit('pause', {totalTime: totalTime.value, currentTime: totalTime.value});
                stopTimer();
                if (error) clearTimeout(error);
                error = setTimeout(() => {
                    window.location.reload();
                }, 60000);
                break;
            case 'online':
                online.value = true;
                console.log('Twitch online');
                emit('play', {totalTime: totalTime.value, currentTime: totalTime.value});
                startTimer();
                if (error) clearTimeout(error);
                break;
        }
    }
});

onUnmounted(() => {
    emit('destroy', {totalTime: totalTime.value, currentTime: totalTime.value});
    stopTimer();
    if (error) clearTimeout(error);
});
</script>
